import React from 'react';
import { TablePagination, TablePaginationProps, Box } from '@mui/material';

type PaginationProps = Omit<TablePaginationProps, 'component'>;

interface TablePaginationWrapperProps extends PaginationProps {
  /**
   * Table content to wrap with pagination above and below.
   */
  children: React.ReactNode;
}

/**
 * A container that renders pagination controls above and below the table content.
 * This keeps pagination visible even when the table is horizontally scrollable.
 *
 * Usage:
 * <TablePaginationWrapper
 *   rowsPerPageOptions={[10, 25, 50]}
 *   count={total}
 *   rowsPerPage={rowsPerPage}
 *   page={page}
 *   onPageChange={handleChangePage}
 *   onRowsPerPageChange={handleChangeRowsPerPage}
 * >
 *   <TableContainer>...</TableContainer>
 * </TablePaginationWrapper>
 */
const TablePaginationWrapper: React.FC<TablePaginationWrapperProps> = ({ children, ...paginationProps }) => {
  return (
    <Box>
      <TablePagination {...paginationProps} component="div" />
      {children}
      <TablePagination {...paginationProps} component="div" />
    </Box>
  );
};

export default TablePaginationWrapper;
